export function NotFound() {
  const styles = { width: "100%", objectFit: "cover" };
  return (
    <img
      style={styles}
      src="https://static.collectui.com/shots/4144886/pikabu-error-404-large"
      alt=""
    />
  );
}
